import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-divider',
  imports: [],
  templateUrl: '../ui/divider.component.html',
})
export class DividerComponent {
@Input() label?:string;
@Input() large: boolean = false;
}
